import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading, isProcessingSession } = useAuth();

  if (loading || isProcessingSession) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0176D3]"></div>
      </div>
    );
  }

  return user ? children : <Navigate to="/" />;
};

export default PrivateRoute;